import React from "react";
import { Client } from "@stomp/stompjs";
import { PowerContext } from "src/contexts/context";
const socketUrl=process.env.REACT_APP_SOCKET_ENDPOINT;
const SOCKET_URL = `ws://${socketUrl}/ws-message`;
class Powers_Stomp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: "You server message here.",
      events: 0,
    };
  }

  componentDidMount() {
    //method is called after the component is rendered.
    let currentComponent = this;
    let onConnected = () => {
      // client.subscribe('/topic/monitor', function (msg) {
      console.log("Connected!!");
      client.subscribe("/topic/power", async (msg) => {
        if (msg.body) {


          var jsonBody = JSON.parse(msg.body);
          if (jsonBody) {
            var powersToUpdate = currentComponent.context.powers.data;
            currentComponent.context.setPowers((powers) => {

              var counter = powers.counter + 1;

              var event = {
                id: powers.counter,
                position:
                  jsonBody.orgName +
                  " - " +
                  jsonBody.siteName +
                  " - " +
                  jsonBody.buildingName +
                  " - " +
                  jsonBody.assetName,
                title: jsonBody.item_sn,
                type: jsonBody.item_field,
                value: jsonBody.value,
                buildingId: jsonBody.buildingId,
                assetSN: jsonBody.asset_sn,
                date: new Date().toLocaleString(),
                details: counter,
              };

              var item = powers.data.find((item) => item.title === event.title);
              
              if (item !== undefined) {
                powersToUpdate.map((item) =>
                  item.title === event.title ? { ...item, ...event } : item
                );
 
                return { data: powersToUpdate, counter: counter };
              }
           

              return { data: [...powers.data, event], counter: counter };
            });
          }
        }
      });
    };

    let onDisconnected = () => {
      console.log("Disconnected!!");
    };

    const client = new Client({
      brokerURL: SOCKET_URL,
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: onConnected,
      onDisconnect: onDisconnected,
    });

    client.activate();
  }

  render() {
    return (
      <div style={{ display: "none" }}>

      </div>
    );
  }
}

export default Powers_Stomp;

Powers_Stomp.contextType = PowerContext;
